__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-04-1785850693-stable-dev/";